"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HospiceMd = void 0;
const helper_1 = require("../../helper");
const EmrConstants_1 = require("../../EmrConstants");
class HospiceMd {
    parse(pastedData, event, callbackEmit) {
        try {
            // Patient Info
            const patientDetails = (0, helper_1.substrInBetween)(pastedData, EmrConstants_1.PARSER_INPUT_TYPE.PERSONAL_INFO, EmrConstants_1.PARSER_INPUT_TYPE.ALLERGIES);
            //**Patient Information*/
            const patientInfo = this.gettingPatientDetails(patientDetails);
            // Insurance
            const insuranceInfo = (0, helper_1.substrInBetween)(pastedData, EmrConstants_1.PARSER_INPUT_TYPE.INSURANCE, EmrConstants_1.PARSER_INPUT_TYPE.DATES_OF_SERVICE);
            const insurance = this.getInsurance(insuranceInfo);
            // Emergency Contact
            const emergencyContact = (0, helper_1.substrInBetween)(pastedData, EmrConstants_1.PARSER_INPUT_TYPE.EMERGENCY_CONTACT_EC, EmrConstants_1.PARSER_INPUT_TYPE.AR_OR_EC);
            // Physician Info
            const physicianDetails = (0, helper_1.substrInBetween)(pastedData, EmrConstants_1.PARSER_INPUT_TYPE.PHYSICIAN_INFO, EmrConstants_1.PARSER_INPUT_TYPE.PAGE);
            const pharmacyDetails = (0, helper_1.substrInBetween)(pastedData, EmrConstants_1.PARSER_INPUT_TYPE.PHARMACY_MAIN, EmrConstants_1.PARSER_INPUT_TYPE.DME);
            const physicianInfo = this.getPrimaryPhysician(emergencyContact, physicianDetails, pharmacyDetails);
            const referralSource = this.getReferralSource(pastedData);
            const sendCallBackData = Object.assign(Object.assign(Object.assign(Object.assign({}, patientInfo), insurance), physicianInfo), referralSource);
            //@callback
            callbackEmit({ parseData: sendCallBackData });
        }
        catch (error) {
            //For Error logs
            callbackEmit({
                parseData: {},
                isDataParsed: 0,
                errorMessage: error ? error === null || error === void 0 ? void 0 : error.message : error,
                errorStack: error === null || error === void 0 ? void 0 : error.stack,
            });
        }
    }
    /**
     * @function gettingPatientDetails
     * @param patientDetails {String}
     * @param sessionSecond {String}
     * @summary Getting Patient name, number, email, dob, address from kinnserHospice
     */
    gettingPatientDetails(patientDetails) {
        let dob;
        if (!patientDetails) {
            return {};
        }
        patientDetails = patientDetails.substr(0, patientDetails.indexOf(EmrConstants_1.PARSER_INPUT_TYPE.INSURANCE));
        const browser = (0, helper_1.detectionBrowser)();
        if (browser == EmrConstants_1.BROWSERS.CHROME &&
            !patientDetails.includes(EmrConstants_1.PARSER_INPUT_TYPE.ErrorSSN)) {
            dob = (0, helper_1.substrInBetween)(patientDetails, EmrConstants_1.PARSER_INPUT_TYPE.DOB, EmrConstants_1.PARSER_INPUT_TYPE.LAST_NAME);
        }
        else if (browser == EmrConstants_1.BROWSERS.CHROME &&
            patientDetails.includes(EmrConstants_1.PARSER_INPUT_TYPE.ErrorSSN)) {
            dob = (0, helper_1.substrInBetween)(patientDetails, EmrConstants_1.PARSER_INPUT_TYPE.ErrorSSN, EmrConstants_1.PARSER_INPUT_TYPE.OPEN_CIRCLE);
        }
        else if (browser == EmrConstants_1.BROWSERS.FIREFOX &&
            patientDetails.includes(EmrConstants_1.PARSER_INPUT_TYPE.ErrorSSN)) {
            dob = (0, helper_1.substrInBetween)(patientDetails, EmrConstants_1.PARSER_INPUT_TYPE.ErrorSSN, EmrConstants_1.PARSER_INPUT_TYPE.OPEN_CIRCLE);
        }
        else if (browser == EmrConstants_1.BROWSERS.FIREFOX &&
            patientDetails.includes(EmrConstants_1.PARSER_INPUT_TYPE.ERRORDOB)) {
            dob = (0, helper_1.substrInBetween)(patientDetails, EmrConstants_1.PARSER_INPUT_TYPE.ERRORDOB, EmrConstants_1.PARSER_INPUT_TYPE.OPEN_CIRCLE);
        }
        if (dob) {
            dob = (0, helper_1.trim)(dob);
        }
        return {
            patientInfo: Object.assign(Object.assign(Object.assign({}, this.patientName(patientDetails)), this.patientPhoneNumberWithAddress(patientDetails)), { email: (0, helper_1.getEmailAddress)(patientDetails), dob: dob && (0, helper_1.getDOB)(dob, true) }),
        };
    }
    /**
     * @function getPrimaryPhysician
     * @param data
     * @param sessionEight
     * @summary Getting Physician and Pharmacy from kinnserHospice
     */
    getPrimaryPhysician(emergencyContact, physicianDetails, sessionEight) {
        const primaryPhy = {
            info: {
                physician: [
                    {
                        name: "",
                        phoneNo: "",
                        countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                        sortOrder: 1,
                    },
                ],
                pharmacy: [this.getPharmacy(sessionEight)],
            },
        };
        const phyInfo = this.getPatPhyCareDetails(physicianDetails.substr(0, physicianDetails.indexOf(EmrConstants_1.PARSER_INPUT_TYPE.FAX)), EmrConstants_1.PARSER_INPUT_TYPE.SELF);
        primaryPhy.info.physician[0].name = phyInfo.name;
        primaryPhy.info.physician[0].phoneNo = phyInfo.phoneNo;
        return primaryPhy;
    }
    /**
     * @function getPharmacy
     * @param data
     */
    getPharmacy(data) {
        const pharmacyData = {
            name: "",
            phoneNo: "",
            countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
            sortOrder: 1,
        };
        //Blank data Return
        const pharmacyName = data.replace(":", "");
        pharmacyData.name = pharmacyName;
        //@Return
        return pharmacyData;
    }
    /**
     * @function getReferralSource
     * @param data
     */
    getReferralSource(data) {
        const referral = {
            referralName: "",
        };
        const referralName = (0, helper_1.substrInBetween)(data, EmrConstants_1.PARSER_INPUT_TYPE.PATIENT_CHOICE, ",");
        referral.referralName = referralName;
        return referral;
    }
    /**
     * @function getInsurance
     * @param insuranceInfo
     * @summary Getting Insurance from kinnserHospice
     */
    getInsurance(insuranceInfo) {
        if (!insuranceInfo) {
            return {};
        }
        const insuranceName = (0, helper_1.substrInBetween)(insuranceInfo, EmrConstants_1.PARSER_INPUT_TYPE.VALID_TILL_PRIMARY, "$");
        //Primary Insurance and Secondary Insurance
        return { insurance: (0, helper_1.trim)(insuranceName) };
    }
    getPatPhyCareDetails(data, breakName) {
        const info = {
            name: "",
            phoneNo: "",
        };
        //Blank data Return
        if (!data) {
            return info;
        }
        const breakPhyData = data.split(/\n/g);
        for (let phyInfo of breakPhyData) {
            if (phyInfo.indexOf(breakName) !== -1) {
                const physicianName = phyInfo.slice(0, phyInfo.indexOf(","));
                info.name = (0, helper_1.trim)(physicianName.replace(breakName, ""));
            }
            if (phyInfo.indexOf(EmrConstants_1.PARSER_INPUT_TYPE.PHONE) !== -1) {
                phyInfo = (0, helper_1.substrInBetween)(phyInfo, EmrConstants_1.PARSER_INPUT_TYPE.PHONE_BREAK, EmrConstants_1.PARSER_INPUT_TYPE.SEPERATOR_SYMBOL);
                phyInfo = phyInfo.replace(/[\s-()]/g, "");
                info.phoneNo = (0, helper_1.changeNumberUSFormat)(phyInfo);
                break;
            }
        }
        return info;
    }
    /**
     * @function patientPhoneNumberWithAddress
     * @param firstSession
     * @summary Patient number or Address both are same session
     */
    patientPhoneNumberWithAddress(firstSession) {
        const info = {
            phoneNo: "",
            address: {
                placeName: "",
            },
        };
        let pAddress = (0, helper_1.substrInBetween)(firstSession, EmrConstants_1.PARSER_INPUT_TYPE.ADDRESS, EmrConstants_1.PARSER_INPUT_TYPE.PHONE.toUpperCase());
        let pNumber = (0, helper_1.substrInBetween)(firstSession, EmrConstants_1.PARSER_INPUT_TYPE.PHONE.toUpperCase(), EmrConstants_1.PARSER_INPUT_TYPE.CELL);
        if (pAddress) {
            pAddress = pAddress.replace(/[\n]/g, " ");
            info.address.placeName = pAddress;
        }
        if (pNumber) {
            pNumber = (0, helper_1.trim)(pNumber).replace(/[\s-()]/g, "");
            info.phoneNo = (0, helper_1.changeNumberUSFormat)(pNumber);
        }
        return info;
    }
    /**
     * @function patientName
     * @param patientDetails {String}
     * @summary Getting Patient First name, Last name from string
     * @returns {name} FullName
     */
    patientName(patientDetails) {
        const name = {
            firstName: "",
            lastName: "",
        };
        const findPatientName = patientDetails.split(/\n/g);
        for (const pName of findPatientName) {
            if (pName.indexOf(EmrConstants_1.PARSER_INPUT_TYPE.FIRST_NAME) !== -1) {
                const firstName = (0, helper_1.substrInBetween)(pName, EmrConstants_1.PARSER_INPUT_TYPE.FIRST_NAME, EmrConstants_1.PARSER_INPUT_TYPE.MI);
                const FName = firstName.replace(EmrConstants_1.PARSER_INPUT_TYPE.FIRST_NAME, "");
                if (!FName) {
                    return;
                }
                name.firstName = (0, helper_1.trim)(FName);
            }
            if (pName.indexOf(EmrConstants_1.PARSER_INPUT_TYPE.LAST_NAME) !== -1) {
                const lastName = (0, helper_1.substrInBetween)(pName, EmrConstants_1.PARSER_INPUT_TYPE.LAST_NAME, EmrConstants_1.PARSER_INPUT_TYPE.FIRST_NAME);
                const LName = lastName.replace(EmrConstants_1.PARSER_INPUT_TYPE.LAST_NAME, "");
                if (!LName) {
                    return;
                }
                name.lastName += (0, helper_1.trim)(LName);
                break;
            }
        }
        return name;
    }
}
exports.HospiceMd = HospiceMd;
